import {Plus} from '@phosphor-icons/react';
import {useCallback, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

import {useTemplate} from '../api.js';
import {useBreakpoint} from '../utils/hooks.js';
import {runAfterAnimations} from '../utils/misc.js';
import TemplatePreviewDialog from './template-chooser/TemplatePreviewDialog.jsx';
import TemplatesList from './TemplatesList.jsx';

export default function Templates() {
  const [selectedTemplateKey, setSelectedTemplateKey] = useState(null);
  const [previewOpen, setPreviewerOpen] = useState(false);
  const [animating, setAnimating] = useState(false);

  const {data: templateDetail, isActuallyLoading} = useTemplate(selectedTemplateKey, {
    enabled: !!selectedTemplateKey,
  });

  const isDesktop = useBreakpoint('desktop');

  const handlePreviewClose = useCallback(() => {
    setAnimating(true);
    setPreviewerOpen(false);
    runAfterAnimations(() => {
      setSelectedTemplateKey(null);
      setAnimating(false);
    });
  }, []);

  const handleTemplateClick = useCallback(templateKey => {
    setSelectedTemplateKey(templateKey);
  }, []);

  useEffect(() => {
    if (templateDetail && !animating && !isActuallyLoading && !previewOpen) {
      setPreviewerOpen(true);
    }
  }, [animating, isActuallyLoading, previewOpen, templateDetail]);

  return (
    <div className="absolute inset-0 top-[57px] mx-auto flex max-w-3xl flex-col overflow-hidden desktop:bottom-8 desktop:top-0 desktop:px-4">
      <div className="flex shrink-0 items-center justify-between p-4  desktop:border-none desktop:px-0 desktop:py-8">
        <h1 className="text-2xl font-semibold text-base-content desktop:text-3xl desktop:font-bold">
          Templates
        </h1>

        <Link
          to="/templates/new"
          className="btn btn-xs flex items-center desktop:btn-accent desktop:btn-sm"
        >
          <Plus size={isDesktop ? 19 : 17} />
          New
        </Link>
      </div>

      <TemplatesList
        onClick={handleTemplateClick}
        isLoadingTemplateKey={isActuallyLoading && selectedTemplateKey}
      />

      <TemplatePreviewDialog
        isOpen={previewOpen}
        onClose={handlePreviewClose}
        template={templateDetail}
      />
    </div>
  );
}
